import { ProductState } from "./product-state.model";

export class TemplateProductPricing {
  private pricingQuotaConfigurationKey: string;
  private state: ProductState;
  private freeCommercialArea: boolean;
  private quota: number;

  public getPricingQuotaConfigurationKey(): string {
    return this.pricingQuotaConfigurationKey;
  }

  public setPricingQuotaConfigurationKey(value: string): void {
    this.pricingQuotaConfigurationKey = value;
  }

  public getState(): ProductState {
    return this.state;
  }

  public setState(value: ProductState): void {
    this.state = value;
  }

  public getFreeCommercialArea(): boolean {
    return this.freeCommercialArea;
  }

  public setFreeCommercialArea(value: boolean): void {
    this.freeCommercialArea = value;
  }

  public getQuota(): number {
    return this.quota;
  }

  public setQuota(value: number): void {
    this.quota = value;
  }
}
